'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getInitials;
var r = /\s+/;

function getInitials() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!name || typeof name !== 'string') {
    return '?';
  }

  return name.replace(r, ' ').split(' ').slice(0, 2).map(function (s) {
    return s.charAt(0);
  }).join('');
}
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJnZXRJbml0aWFscyIsInIiLCJuYW1lIiwicmVwbGFjZSIsInNwbGl0Iiwic2xpY2UiLCJtYXAiLCJzIiwiY2hhckF0Iiwiam9pbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBRXdCQSxXO0FBRnhCLElBQU1DLElBQUksS0FBVjs7QUFFZSxTQUFTRCxXQUFULEdBQWlDO0FBQUEsTUFBWEUsSUFBVyx1RUFBSixFQUFJOztBQUM5QyxNQUFJLENBQUNBLElBQUQsSUFBUyxPQUFPQSxJQUFQLEtBQWdCLFFBQTdCLEVBQXVDO0FBQ3JDLFdBQU8sR0FBUDtBQUNEOztBQUVELFNBQU9BLEtBQ0pDLE9BREksQ0FDSUYsQ0FESixFQUNPLEdBRFAsRUFFSkcsS0FGSSxDQUVFLEdBRkYsRUFHSkMsS0FISSxDQUdFLENBSEYsRUFHSyxDQUhMLEVBSUpDLEdBSkksQ0FJQTtBQUFBLFdBQUtDLEVBQUVDLE1BQUYsQ0FBUyxDQUFULENBQUw7QUFBQSxHQUpBLEVBS0pDLElBTEksQ0FLQyxFQUxELENBQVA7QUFNRCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHIgPSAvXFxzKy9cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gZ2V0SW5pdGlhbHMgKG5hbWUgPSAnJykge1xuICBpZiAoIW5hbWUgfHwgdHlwZW9mIG5hbWUgIT09ICdzdHJpbmcnKSB7XG4gICAgcmV0dXJuICc/J1xuICB9XG5cbiAgcmV0dXJuIG5hbWVcbiAgICAucmVwbGFjZShyLCAnICcpXG4gICAgLnNwbGl0KCcgJylcbiAgICAuc2xpY2UoMCwgMilcbiAgICAubWFwKHMgPT4gcy5jaGFyQXQoMCkpXG4gICAgLmpvaW4oJycpXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/get-initials/lib/index.js
// module id = 575
// module chunks = 0